import { ReactNode } from "react";
import Header from "./Header"
import Footer from "./Footer"
import { ThemeProvider } from "./ThemeProvider"
// import FlashMessages from "../components/FlashMessages"
import { Toaster } from "../components/ui/toaster"

interface LayoutProps {
  children: ReactNode;
}

const Layout = ({ children }: LayoutProps) => {
  return (
    <ThemeProvider defaultTheme="light" storageKey="codeware-ui-theme">
      <div className="min-h-screen bg-background text-foreground">
        <Header />
        {/* <FlashMessages /> */}
        <main className="flex-1">
          {children}
        </main>
        <Footer />
        <Toaster />
      </div>
    </ThemeProvider>
  )
}

export default Layout